import { render } from "./Feature.vue?vue&type=template&id=297ac21a&scoped=true"
import script from "./Feature.vue?vue&type=script&lang=ts"
export * from "./Feature.vue?vue&type=script&lang=ts"

import "./Feature.vue?vue&type=style&index=0&id=297ac21a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-297ac21a"

export default script